import {
    type DiscoveryNode,
    type DiscoveryStrategy,
    type DiscoveryStrategyFactory,
    DiscoveryStrategyPriorities
} from '../index.ts';
import {MulticastDiscoveryStrategy} from './MulticastDiscoveryStrategy.ts';
import {GROUP, PORT} from './MulticastProperties.ts';
import {type Properties, type  PropertyDefinition} from '../../config/Properties.ts';
import {type Logger} from '../../logging.ts';

const PROPERTY_DEFINITIONS: ReadonlyArray<PropertyDefinition> = [
    GROUP,
    PORT
];

export class MulticastDiscoveryStrategyFactory implements DiscoveryStrategyFactory {
    readonly priority = DiscoveryStrategyPriorities.UNKNOWN;
    newDiscoveryStrategy(discoveryNode: DiscoveryNode, logger: Logger, prop: Properties): DiscoveryStrategy {
        return new MulticastDiscoveryStrategy(discoveryNode, logger, prop);
    }

    async isAutoDetectionApplicable(): Promise<boolean> {
        return false;
    }

    getConfigurationProperties(): ReadonlyArray<PropertyDefinition> {
        return PROPERTY_DEFINITIONS;
    }
}
